import Plugin from '../core/Plugin';

/**
 * PageBreakPlugin - Handles insertion of page breaks for standard letter paper (8.5" x 11")
 * 
 * Page breaks are visual indicators that show where pages would break when printed on standard
 * letter paper. In page view mode, content after a page break appears on the next virtual page.
 */
class PageBreakPlugin extends Plugin {
  constructor(editor, options = {}) {
    super(editor, options);
    this.name = 'PageBreak';
  }

  init() {
    super.init();
    // No additional initialization needed
  }

  getToolbarButtons() {
    // We don't add a separate button - page breaks are inserted via the Insert dropdown
    return [];
  }

  /**
   * Insert a page break at the current cursor position
   * Page breaks are represented as a div with class 'quillkit-page-break'
   */
  insertPageBreak() {
    const selection = window.getSelection();
    if (!selection || selection.rangeCount === 0) {
      return;
    }

    const range = selection.getRangeAt(0);
    
    // Create the page break element
    const pageBreak = document.createElement('div');
    pageBreak.className = 'quillkit-page-break';
    pageBreak.contentEditable = 'false';
    
    // Create the label span
    const label = document.createElement('span');
    label.className = 'quillkit-page-break-label';
    label.textContent = 'Page Break';
    pageBreak.appendChild(label);
    
    // Delete any selected content first
    range.deleteContents();
    
    // Insert the page break
    range.insertNode(pageBreak);
    
    // Create a new paragraph after the page break to continue editing
    const newParagraph = document.createElement('p');
    const br = document.createElement('br');
    newParagraph.appendChild(br);
    
    // Insert the paragraph after the page break
    if (pageBreak.nextSibling) {
      pageBreak.parentNode.insertBefore(newParagraph, pageBreak.nextSibling);
    } else {
      pageBreak.parentNode.appendChild(newParagraph);
    }
    
    // Move cursor to the new paragraph
    range.setStart(newParagraph, 0);
    range.collapse(true);
    selection.removeAllRanges();
    selection.addRange(range);
    
    // Record history
    this.editor.saveToHistory();
  }

  executeCommand(command) {
    if (command === 'pageBreak') {
      this.insertPageBreak();
    }
  }

  getMetadata() {
    return {
      name: 'Page Break',
      version: '1.0.0',
      description: 'Provides page break insertion for standard letter paper (8.5" x 11")',
      author: 'AtlaraFirm',
    };
  }
}

export default PageBreakPlugin;
